
import { useEffect } from "react";
import { useTranslations } from "use-intl";
import { X } from "lucide-react";
import { SqlDisplay } from "@/components/ui/sql-display";

interface SqlModalProps {
  sql: string;
  onClose: () => void;
}

export function SqlModal({ sql, onClose }: SqlModalProps) {
  const t = useTranslations("workflows");
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <div
      className="fixed inset-0 z-9999 flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className="flex w-full max-w-3xl flex-col rounded-xl bg-white shadow-2xl dark:bg-gray-900"
        style={{ maxHeight: "calc(100vh - 64px)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex shrink-0 items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700">
          <h3 className="font-semibold text-gray-900 dark:text-white">{t("modals.sql_title")}</h3>
          <button
            onClick={onClose}
            className="rounded p-1 text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800"
          >
            <X className="size-5" />
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-hidden p-4">
          <SqlDisplay sql={sql} maxHeight="calc(100vh - 200px)" />
        </div>
        <div className="flex shrink-0 justify-end border-t border-gray-200 px-4 py-3 dark:border-gray-700">
          <button
            onClick={onClose}
            className="rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
          >
            {t("modals.sql_close")}
          </button>
        </div>
      </div>
    </div>
  );
}
